"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModel = void 0;
var tslib_1 = require("tslib");
var form_1 = require("../form");
var brightnessCorrection_state_1 = require("./brightnessCorrection/brightnessCorrection.state");
var collection_base_1 = require("./collection.base");
var collection_loader_1 = require("./collection.loader");
var collection_state_1 = require("./collection.state");
var cropParameter_state_1 = require("./cropParameter/cropParameter.state");
var drawable_state_1 = require("./drawable/drawable.state");
var capture_provider_1 = require("./fields/provider/capture.provider");
var collection_provider_1 = require("./fields/provider/collection.provider");
var imageVisibility_state_1 = require("./imageVisibility/imageVisibility.state");
/**
 * This class is a proxy to store all its data inside of the state.
 *
 * This is done to allow a easy place to record all changes to the Collection,
 * which can be used for editing, undo/redo stacks.
 *
 * **Do not** add any properties directly to this class
 */
var CollectionModel = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModel, _super);
    function CollectionModel(form, loader) {
        var _this = _super.call(this, null, null, form) || this;
        _this.brightnessCorrectionState = {};
        _this.cropParameterState = {};
        _this.imageVisibilityState = {};
        /** State proxy which can be used to track edits */
        _this.proxyState = null;
        _this._fieldCache = {};
        _this._fieldCacheCount = 0;
        _this.loader = loader;
        _this._state = new collection_state_1.CollectionModelState(_this.loader);
        return _this;
    }
    CollectionModel.createLoader = function () {
        return new collection_loader_1.IkeCollectionLoaderFromState();
    };
    Object.defineProperty(CollectionModel.prototype, "state", {
        get: function () {
            if (this.isEditing && this.proxyState) {
                return this.proxyState;
            }
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "id", {
        get: function () { return this.state.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "instanceId", {
        get: function () { return this.state.instanceId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "uuid", {
        get: function () { return this.state.uuid; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "revision", {
        get: function () { return this.state.revision; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "jobId", {
        get: function () { return this.state.jobId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "updatedAt", {
        get: function () { return this.state.updatedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "updatedBy", {
        get: function () { return this.state.updatedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "createdAt", {
        get: function () { return this.state.createdAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collectedBy", {
        get: function () { return this.state.collectedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collectedWith", {
        get: function () { return this.state.collectedWith; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "assignedTo", {
        get: function () { return this.state.assignedTo; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collectedAt", {
        /**
         * @deprecated Use {@link getCollectedAt} instead.
         */
        get: function () {
            var e_1, _a;
            if (this.state.collectedAt != null) {
                return this.state.collectedAt;
            }
            var captureIds = capture_provider_1.CaptureProvider.getCaptureIds(this);
            var earliestDate = null;
            try {
                for (var captureIds_1 = tslib_1.__values(captureIds), captureIds_1_1 = captureIds_1.next(); !captureIds_1_1.done; captureIds_1_1 = captureIds_1.next()) {
                    var captureId = captureIds_1_1.value;
                    var fetchable = this.loader.Capture.getById(captureId);
                    // Only calculate when all captures are loaded
                    if (!fetchable.hasFetched) {
                        return null;
                    }
                    var capture = fetchable.value;
                    if (capture.collectedAt == null) {
                        continue;
                    }
                    if (earliestDate == null || capture.collectedAt.iso < earliestDate) {
                        earliestDate = capture.collectedAt.iso;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (captureIds_1_1 && !captureIds_1_1.done && (_a = captureIds_1.return)) _a.call(captureIds_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (earliestDate != null) {
                this.state.collectedAt = new Date(earliestDate);
            }
            return this.state.collectedAt;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModel.prototype.getCollectedAt = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var captureIds, earliestDate, captureIds_2, captureIds_2_1, captureId, fetchable, capture, e_2_1;
            var e_2, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.state.collectedAt != null) {
                            return [2 /*return*/, this.state.collectedAt];
                        }
                        captureIds = capture_provider_1.CaptureProvider.getCaptureIds(this);
                        earliestDate = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        captureIds_2 = tslib_1.__values(captureIds), captureIds_2_1 = captureIds_2.next();
                        _b.label = 2;
                    case 2:
                        if (!!captureIds_2_1.done) return [3 /*break*/, 5];
                        captureId = captureIds_2_1.value;
                        fetchable = this.loader.Capture.getById(captureId);
                        return [4 /*yield*/, fetchable.fetch()];
                    case 3:
                        capture = _b.sent();
                        if (capture.collectedAt == null) {
                            return [3 /*break*/, 4];
                        }
                        if (earliestDate == null || capture.collectedAt.iso < earliestDate) {
                            earliestDate = capture.collectedAt.iso;
                        }
                        _b.label = 4;
                    case 4:
                        captureIds_2_1 = captureIds_2.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (captureIds_2_1 && !captureIds_2_1.done && (_a = captureIds_2.return)) _a.call(captureIds_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        if (earliestDate != null) {
                            this.state.collectedAt = new Date(earliestDate);
                        }
                        return [2 /*return*/, this.state.collectedAt];
                }
            });
        });
    };
    Object.defineProperty(CollectionModel.prototype, "status", {
        /**
         * Look up the collection status using the status field from the metadata.
         *
         * If the collection does not have a status field, no field will be returned.
         */
        get: function () {
            var statusField = this.schema.metadata.getStatusField();
            if (statusField == null) {
                return null;
            }
            return this.getField(statusField.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "mapMarkerColor", {
        /**
         * Look up the collection map color using the map color field from the metadata.
         * If the collection does not have a map color field, no field will be returned.
         */
        get: function () {
            var mapColorField = this.schema.metadata.getMapColorField();
            if (mapColorField == null) {
                return null;
            }
            var color = null;
            if (mapColorField instanceof form_1.FormModelFieldSelectList) {
                color = mapColorField.options[0].color;
                var field_1 = this.getField(mapColorField.id);
                if (field_1) {
                    mapColorField.options.forEach(function (option) {
                        if (option.value === field_1.value) {
                            color = option.color;
                        }
                    });
                }
            }
            else if (mapColorField instanceof form_1.FormModelFieldNestedList) {
                var field = this.getField(mapColorField.id);
                color = '#a0aec0';
                if (field) {
                    if (field.hasValue()) {
                        for (var i = 0; i < mapColorField.options.values.length; i++) {
                            if (mapColorField.options.values[i].value === field.value[0]) {
                                color = mapColorField.options.values[i].color;
                            }
                        }
                    }
                }
            }
            return color;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new proxy state layer, this can be used to track changes to a collection.
     * @returns Created proxy state
     */
    CollectionModel.prototype.beginEdit = function (editState) {
        var newState = editState(this._state);
        this.proxyState = newState;
        return newState;
    };
    /**
     * Remove the proxy state layer, this will undo any changes made to a collection
     */
    CollectionModel.prototype.finishEdit = function () {
        if (this.proxyState == null) {
            throw new Error('Unable to finish editing, no edit in place');
        }
        this.proxyState = null;
    };
    Object.defineProperty(CollectionModel.prototype, "isEditing", {
        get: function () {
            return this.proxyState != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collection", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "recordedAt", {
        /**
         * Get the time the collection was created, using the collectedAt if it exists otherwise the time it was uploaded
         *
         * @deprecated Use {@link getRecordedAt} instead.
         */
        get: function () {
            return this.collectedAt == null ? this.createdAt : this.collectedAt;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModel.prototype.getRecordedAt = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectedAt;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCollectedAt()];
                    case 1:
                        collectedAt = _a.sent();
                        return [2 /*return*/, collectedAt !== null && collectedAt !== void 0 ? collectedAt : this.createdAt];
                }
            });
        });
    };
    CollectionModel.prototype.getDrawableState = function (captureId) {
        if (!this.state.drawableStates.has(captureId)) {
            this.state.drawableStates.set(captureId, new drawable_state_1.CollectionModelDrawableState(this, captureId));
        }
        var drawableState = this.state.drawableStates.get(captureId);
        if (!drawableState) {
            throw new Error("Unable to get drawable state for capture ".concat(captureId));
        }
        return drawableState;
    };
    CollectionModel.prototype.getImageVisibilityState = function (captureId) {
        var existing = this.imageVisibilityState[captureId];
        if (existing == null) {
            existing = this.imageVisibilityState[captureId] = new imageVisibility_state_1.CollectionModelImageVisibilityState(this, captureId);
        }
        return existing;
    };
    CollectionModel.prototype.getBrightnessCorrectionState = function (captureId) {
        var existing = this.brightnessCorrectionState[captureId];
        if (existing == null) {
            existing = this.brightnessCorrectionState[captureId] = new brightnessCorrection_state_1.CollectionModelBrightnessCorrectionState(this, captureId);
        }
        return existing;
    };
    CollectionModel.prototype.getCropParameterState = function (captureId) {
        var existing = this.cropParameterState[captureId];
        if (existing == null) {
            existing = this.cropParameterState[captureId] = new cropParameter_state_1.CollectionModelCropParameterState(this, captureId);
        }
        return existing;
    };
    /**
     * Find a field using its unique field Id
     * Used for quickly looking up field links.
     *
     * @param fieldId Unique field Id including subformId
     * @returns collection field if it exists
     */
    CollectionModel.prototype.findField = function (fieldId) {
        var existing = this._fieldCache[fieldId];
        if (existing !== undefined) {
            return existing;
        }
        var output = null;
        this.forEachField(function (field) {
            if (field.id === fieldId) {
                output = field;
                return false; // abort the search
            }
            return true;
        });
        this._fieldCache[fieldId] = output;
        this._fieldCacheCount++;
        // Paranoia incase the cache gets too large
        if (this._fieldCacheCount > 1000) {
            this._fieldCacheCount = 0;
            this._fieldCache = {};
        }
        return output;
    };
    /**
     * Collections are not loaded with all their information.
     *
     * Wait for all the linked data to load in
     *
     * If any object in the returned list is null, it means the collection failed to load something.
     *
     * @return List of objects that were loaded
     */
    CollectionModel.prototype.ready = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var captureIds, collectionIds, fetchables, captures, i, capture, collectionIds_1, collectionIds_1_1, collectionId;
            var e_3, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        captureIds = capture_provider_1.CaptureProvider.getCaptureIds(this);
                        collectionIds = collection_provider_1.CollectionProvider.getCollectionIds(this);
                        fetchables = [];
                        return [4 /*yield*/, Promise.all(captureIds.map(function (id) { return _this.loader.Capture.getById(id).fetch(); }))];
                    case 1:
                        captures = _b.sent();
                        for (i = 0; i < captures.length; i++) {
                            capture = captures[i];
                            if (capture == null) {
                                throw new Error('Unable to load capture: ' + captureIds[i]);
                            }
                            if (capture.calibrationid == null) {
                                continue;
                            }
                            fetchables.push(this.loader.Calibration.getById(capture.calibrationid).fetch());
                        }
                        try {
                            for (collectionIds_1 = tslib_1.__values(collectionIds), collectionIds_1_1 = collectionIds_1.next(); !collectionIds_1_1.done; collectionIds_1_1 = collectionIds_1.next()) {
                                collectionId = collectionIds_1_1.value;
                                fetchables.push(this.loader.CollectionSummary.getById(collectionId).fetch());
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (collectionIds_1_1 && !collectionIds_1_1.done && (_a = collectionIds_1.return)) _a.call(collectionIds_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        return [4 /*yield*/, Promise.all(fetchables)];
                    case 2: 
                    // Note: We could fetch all linked collection models here, but if we did, it would
                    // recursively load all of the linked collections, which may trigger an infinite loop or
                    // an unnecessarily large number of fetches.
                    // So if you need to load linked collection models, use `CollectionModelState.getCollectionModelAsync()`
                    // or `CollectionModelFieldVector.getLinkedCollection()`.
                    return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return CollectionModel;
}(collection_base_1.CollectionModelBase));
exports.CollectionModel = CollectionModel;
//# sourceMappingURL=collection.data.js.map